// servicesData.js - Fetches services from the server
import ENV from '../config/env';

const API_BASE = ENV.API_BASE;

// Function to fetch services from server
export const fetchServices = async () => {
    try {
        const response = await fetch(`${API_BASE}/services`);
        if (response.ok) {
            const data = await response.json();
            return data.services || [];
        }
    } catch (error) {
        console.error('Error fetching services:', error);
    }
    return []; // Always return empty array on error
};

// For backward compatibility, we'll keep the export but make it async
export let servicesData = [];
export let rawServicesData = [];

// Initialize function to load services
export const loadServices = async () => {
    const services = await fetchServices();
    servicesData = services;
    rawServicesData = services;
    return services;
};

// Helper function to get service by ID
export const getServiceById = (id, services = servicesData) => {
    return services.find(service => service.id === id);
};

// Helper function to get service by folder name
export const getServiceByFolder = (folderName, services = servicesData) => {
    return services.find(service => service.galleryFolder === folderName);
};